import React, {useContext, useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {Input} from 'reactstrap';
import {SpinnerButton} from 'common/SpinnerButton';
import {AuthContext} from "contexts/AuthContext";
import {AuthLayout} from "./AuthLayout"
import {login} from "utils/api";
import './style.css';
import {InputWithError} from "../../common/InputWithError";

export const SignIn = () => {
    const {signIn, logout} = useContext(AuthContext);
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errors, setErrors] = useState(null);

    const onSubmit = async () => {
        setSubmitting(true);

        try {
            const res = await login(email, password)

            const token = res?.dpb_token;

            if (token) {
                signIn(token);
                navigate('/');
            }
        } catch (err) {
            setErrors({errors: {'password': [{'message': err?.message || err}]}});
        }

        setSubmitting(false);
    };

    useEffect(() => {
        setErrors(null);
    }, [password, email]);

    useEffect(() => {
        logout();
    }, []);

    const signInForm = () => {
        return (
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <div className="text-center w-100 px-3 px-md-5">
                    <div className="login-box shadow-sm">
                        <h4 className="mb-5 login-title">Welcome back</h4>
                        <div className="mb-3 text-start">
                            <label htmlFor="email" className="form-label">Email</label>
                            <Input
                                id="email"
                                className="form-control rounded-pill"
                                name="email"
                                value={email}
                                type="email"
                                autoComplete="email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <div className="mb-7 text-start">
                            <label htmlFor="password" className="form-label">Password</label>
                            <InputWithError
                                id="password"
                                name="password"
                                className="form-control rounded-pill"
                                value={password}
                                type="password"
                                onChange={setPassword}
                                errorObj={errors}
                                autoComplete="password"
                            />
                        </div>
                        <div className="d-grid mb-4">
                            <SpinnerButton
                                color="primary"
                                block
                                disabled={email.length < 1 || password.length < 1}
                                onClick={onSubmit}
                                submitting={submitting}
                                title="Log In"
                                className="text-bold rounded-pill mt-3"
                            />

                        </div>
                        <div className="mb-3">
                            <Link className="nav-link underline-important" to="/forgot-password">
                                Forgot password?
                            </Link>

                        </div>
                        <div>
                            Don't have an account?&nbsp;&nbsp;
                            <Link className="underline-important" to="/signup">
                                Sign Up
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return <AuthLayout authForm={signInForm()}/>
};
